// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { GeminiRights, ShoppingCenter } from '../../../../types/shoppingCenterType';
import type { CoqueRetailer, Store } from '../../../../types/apolloType';
import RoiComponent from '../RoiComponent';
import BestDealComponent from '../BestDealComponent';
import CrossSell from './tlp/CrossSell';
import shoppingCenterApi from '../../../../network/api/shoppingCenterApi';
import CatchmentArea from './CatchmentArea';
import Goodwill from './goodwill/Goodwill';
import AttractiveScore from './attractiveScore/AttractiveScore';
import type { UrlParam } from '../../../../utils/urlUtils';

type Props = {
  dispatch: () => void,
  apiKey: string,
  currentStore: Store,
  shoppingCenter: ShoppingCenter,
  currentRetailer: CoqueRetailer,
  topRetailerIds: Array<number>,
  addedCustomRetailer: CoqueRetailer,
  locationParams: UrlParam,
  userGeminiRights: GeminiRights,
}

type State = {
  shoppingCenterStores: Store[],
}

class StoreDealPerformance extends React.Component<Props, State> {
  state = {
    shoppingCenterStores: [],
  };

  componentDidMount() {
    this.fetchShoppingCenterStores(this.props.shoppingCenter.id);
  }

  fetchShoppingCenterStores = (pcId: string) => {
    shoppingCenterApi.fetchStores(pcId)
      .then(response => response.json())
      .then((response: Store[]) => this.setState({ shoppingCenterStores: response }));
  }

  render() {
    const { currentRetailer, shoppingCenter } = this.props;
    return (
      <>
        <div className="retailer-data-container center">
          <div className="filter-bar-container-external">
            <div className="filter-bar-container">
              <div className="filter-bar-title">
                <Translate value="bestDeals.title" />
              </div>
            </div>
          </div>
          <div className="retailer-data">
            <p><Translate value="bestDeals.subtitle" /></p>
            <BestDealComponent
              dispatch={this.props.dispatch}
              shoppingCenter={shoppingCenter}
              currentRetailer={currentRetailer}
            />
          </div>
        </div>
        <div className="retailer-data-container center">
          <div className="filter-bar-container-external">
            <div className="filter-bar-container">
              <div className="filter-bar-title">
                <Translate value="clusters.title" />
              </div>
            </div>
          </div>
          <div className="retailer-data">
            <p><Translate value="bestDeals.subtitle" /></p>
            <div className="clusters">
              <CrossSell
                shoppingCenterStores={this.state.shoppingCenterStores}
                currentRetailer={currentRetailer}
                sameBl1={false}
              />
              <CrossSell
                shoppingCenterStores={this.state.shoppingCenterStores}
                currentRetailer={currentRetailer}
                sameBl1
              />
            </div>
          </div>
        </div>
        <div className="retailer-data-container">
          <div className="filter-bar-container-external">
            <div className="filter-bar-container">
              <div className="filter-bar-title">
                <Translate value="comparator.catchmentArea" />
              </div>
            </div>
          </div>
          <div className="retailer-data">
            <CatchmentArea
              apiKey={this.props.apiKey}
              shoppingCenter={shoppingCenter}
              currentRetailer={currentRetailer}
            />
          </div>
        </div>
        {
          this.props.userGeminiRights.isGeminiAdmin
          && this.props.topRetailerIds.includes(this.props.currentRetailer.codeRetailerProposition)
          && (
            <>
              <div className="retailer-data-container center">
                <div className="filter-bar-container-external">
                  <div className="filter-bar-container">
                    <div className="filter-bar-title">
                      <Translate value="goodwill.title" />
                    </div>
                  </div>
                </div>
                <div className="retailer-data">
                  <p><Translate value="goodwill.subtitle" /></p>
                  <Goodwill
                    dispatch={this.props.dispatch}
                    shoppingCenter={shoppingCenter}
                    currentRetailer={currentRetailer}
                    topRetailerIds={this.props.topRetailerIds}
                    oldRetailer={this.props.currentStore}
                    userGeminiRights={this.props.userGeminiRights}
                  />
                </div>
              </div>
              <div className="retailer-data-container center">
                <div className="filter-bar-container-external">
                  <div className="filter-bar-container">
                    <div className="filter-bar-title">
                      <Translate value="attractiveScore.title" />
                    </div>
                  </div>
                </div>
                <div className="retailer-data">
                  <AttractiveScore currentRetailer={currentRetailer}/>
                </div>
              </div>
            </>
          )
        }
        <div className="retailer-data-container">
          <div className="filter-bar-container-external">
            <div className="filter-bar-container">
              <div className="filter-bar-title">
                <Translate value="roi.dealPerformanceTitle" />
              </div>
            </div>
          </div>
          <div className="retailer-data">
            <p><Translate value="roi.subtitle" /></p>
            <div className="roi-deal-performance-container">
              <RoiComponent
                currentRetailer={currentRetailer}
                mainStoreCodstr={this.props.currentStore.codstr}
                addedCustomRetailer={this.props.addedCustomRetailer}
                locationParams={this.props.locationParams}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default StoreDealPerformance;
